import $ from 'jquery'

$number.prototype.pad = function (cipher) {
  if (cipher < 1) {
    return this.numStr
  }

  cipher -= this.numStr.length

  return (
    new Array(cipher + (/\./.test(this.numStr) ? 2 : 1)).join('0') + this.numStr
  )
}

$number.prototype.comma = function () {
  var parts = this.numStr.split('.')

  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  return parts.join('.')
}

$number.prototype.tags = function (classPrefix, suffixTag) {
  var $tag = $('<b></b>')
  var numTags = $('<div></div>')
  var prefix = classPrefix || 'n'

  $.each(this.numStr.split(''), function () {
    if (this == ',') {
      $tag
        .clone()
        .addClass(prefix + 'comma')
        .appendTo(numTags)
    } else {
      $tag
        .clone()
        .addClass(prefix + this)
        .appendTo(numTags)
    }
  })

  if (suffixTag) {
    $(suffixTag).appendTo(numTags)
  }

  return numTags.html()
}

$number.prototype.text = function (options) {
  var parts = this.numStr.split('.')
  var sep = []
  var revalue = []
  var unit = ['', '만', '억', '조']
  var $wrapTag = $('<span class="number-with-text"></span>')
  var $numberTag = $('<em></em>')
  var $unitTag = $('<b></b>')
  var result = ''
  options = $.extend(
    {
      delimiter: '',
      comma: false,
      tag: false,
    },
    options
  )

  parts[0] = parts[0].replace(/,/g, '')
  parts[0] = parts[0].replace(/\B(?=(\d{4})+(?!\d))/g, ',')

  sep = parts[0].split(',')

  $.each(
    sep.reverse(),
    $.proxy(function (index, el) {
      el = parseInt(el, 10)

      if (el > 0) {
        el = options.comma
          ? this.comma.call({ numStr: el.toString() })
          : el.toString()

        if (options.tag) {
          var $div = $('<div></div>')
          $numberTag.clone().text(el).appendTo($div)
          $unitTag.clone().text(unit[index]).appendTo($div)
          el = $div.html()
        } else {
          el = el + unit[index] + options.delimiter
        }
      } else {
        el = ''
      }

      revalue.push(el)
    }, this)
  )

  result = $.trim(revalue.reverse().join(''))

  if (options.tag) {
    var $div = $('<div></div>')
    $wrapTag.html(result || 0).appendTo($div.empty())
    result = $div.html()
  }
  return result
}

export function $number(num) {
  if (!(this instanceof $number)) {
    return new $number(num)
  }

  this.numStr = num.toString()
}
